import Typed from "react-typed";
import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";

// TODO send it to elements/widgets folder
function TypingText({ id, db, device, gs }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    //=========================
    const fixStyle = decodeStyle(ps.fixStyle, gs);

    const style = decodeStyle(ps.style, gs);
    const styleTab = tablet(device) ? decodeStyle(ps.tablet, gs) : {};
    const styleMob = mobile(device) ? decodeStyle(ps.mobile, gs) : {};

    if (isHidden(ps.classes, device)) {
        return null;
    }

    const all_style = {
        ...fixStyle,
        ...style,
        textAlign: input.textAlign,
        fontWeight: input.bold ? "bold" : "normal",
        textTransform: input.uppercase ? "uppercase" : "none",
        ...(tablet(device) && styleTab),
        ...(mobile(device) && styleMob),
        outline: "none",
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Typed
                strings={input.textSequence.filter((text) => text.length > 0)}
                typeSpeed={input.typeSpeed}
                backSpeed={input.backSpeed}
                startDelay={input.startDelay * 100}
                backDelay={input.backDelay * 100}
                loop={input.loop}
                shuffle={input.shuffle}
                showCursor={input.showCursor}
                style={{
                    ...all_style,
                    fontSize: input.fontSize,
                    lineHeight: `${input.fontSize * input.lineHeight}px`,
                }}
            />
        </div>
    );
}

export default TypingText;

// https://github.com/mattboldt/typed.js
// https://www.npmjs.com/package/react-typed
